export type SiteInfo = {
  site: string;
  site_name: string;
  golden_site_id?: string | null;
  norm_site_name?: string | null;
  date_activated: string;
  region: string;
  country: string;
  country_code: string;
  address: string;
  coordinates: { lat: number; lng: number };
  investigator_name: string;
  investigator_email: string;
  subject_count: number;
  screen_success_count: number;
  screen_failure_count: number;
  screen_in_progress_count: number;
  enrolled_count: number;
  not_enrolled_count: number;
  active_count: number;
  complete_count: number;
  early_termination_count: number;
  subj_with_ae_count: number;
  subj_with_siae_count: number;
  subj_with_sae_count: number;
  data_discrepancies_count: number;
  participant_protocol_deviations_count: number;
  site_protocol_deviations_count: number;
  missing_datapoint_count: number;
  screen_success_percent: number;
  screen_failure_percent: number;
  screen_in_progress_percent: number;
  enrolled_percent: number;
  not_enrolled_percent: number;
  active_percent: number;
  complete_percent: number;
  early_termination_percent: number;
  subj_with_sae_percent: number;
  subj_with_siae_percent: number;
  subj_with_ae_percent: number;
  missing_data_percent: number;
  // Some datasets expose these percent fields with `subject_with_*` naming.
  subject_with_sae_percent?: number;
  subject_with_siae_percent?: number;
  subject_with_ae_percent?: number;
  // Optional derived fields used in sites overview metrics cards.
  months_open_count_derived?: number;
  enrollment_rate_derived?: number;
  enrollment_rate_unit_derived?: string;
  screen_failure_rate_derived?: number;
  screen_failure_rate_unit_derived?: string;
  open_queries_count_derived?: number;
  overdue_ecrfs_count_derived?: number;
  ecrf_requiring_sdv_count_derived?: number;
  days_on_site_required_count_derived?: number;
  sdv_complete_percent_derived?: number;
  long_open_mvr_action_items_count_derived?: number;
  long_open_mvr_action_items_count_unit_derived?: string;
  open_mvr_action_items_count_derived?: number;
  closed_mvr_action_items_count_derived?: number;
};

export const hasValidCoordinates = (site: SiteInfo) =>
  Number.isFinite(site.coordinates?.lat) &&
  Number.isFinite(site.coordinates?.lng);
